import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { SvgIconService } from 'app/shared/services/svgIcons.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
@Component({
  selector: 'app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  showTopBar = true;
  constructor(
    @Inject(DOCUMENT) private document: any,
    private _fuseSplashScreenService: FuseSplashScreenService, // import mandatory otherwise splash screen never disappear
    private _platform: Platform,
    private iconService: SvgIconService,
    private router: Router, 
    private activatedRoute: ActivatedRoute
  ) {
    // Add is-mobile class to the body if the platform is mobile
    if (this._platform.ANDROID || this._platform.IOS) {
      this.document.body.classList.add('is-mobile');
    }
    this.iconService.registerIcons();

    // Read route custom data parameters to show topbar or not (may be useful for other embeds of editor page into player)
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        mergeMap(route => route.data)
      )
      .subscribe(data => {
        this.showTopBar = !data['hideTopBar'];
      });
  }
}
